import { Row, Col, Container, Button } from 'react-bootstrap'
import Image from 'next/image'

const Intro = (props) => {
  const { t } = props
  return (
    <div className='intro-flirt-container' >
      <Container >
        <Row className='intro-flirt-container__row'>
          <Col
            xl={{ span: 6, order: 'last' }}
            lg={{ span: 6, order: 'last' }}
            md={{ span: 12, order: 'first' }}
            xs={{ span: 12, order: 'first' }}>
            {/* <Image
              loader={({ src }) => `https://flirtbees.com/images/${src}`}
              src='img_1.webp'
              alt="Intro image 1"
              className='intro-flirt-container__image'
              width='500px'
              height='445px'
              quality={100}
              loading='eager'
            /> */}

            <amp-img src={`https://flirtbees.com/images/img_1.webp`} alt="Intro image 1"
              className='intro-flirt-container__image'
              layout="responsive"
              width="500" height="445" ></amp-img>
          </Col>
          <Col
            xl={{ span: 6, order: 'last' }}
            lg={{ span: 6, order: 'last' }}
            md={{ span: 12, order: 'last' }}
            xs={{ span: 12, order: 'last' }}>
            <div className='intro-flirt-container__text'>
              <h3 className='intro-flirt-container__text-about'>
                {t('intro2.h3-1')} <span style={{ color: '#ec0043' }} >{t('intro2.h3-2')}</span> {t('intro2.h3-3')}
              </h3>
              <div className='intro-flirt-container__text-line'></div>
              <p className='intro-flirt-container__text-sub-about'>
                {t('intro2.p-1')}<span style={{ color: '#ec0043' }} >{t('intro2.p-2')}</span>{t('intro2.p-3')}
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xl={{ span: 6, order: 'first' }}
            lg={{ span: 6, order: 'first' }}
            md={{ span: 12, order: 'last' }}
            xs={{ span: 12, order: 'last' }}>
            <div className='intro-flirt-container__text'>
              <h3 className='intro-flirt-container__text-about' >
                {t('intro3.h3-1')} <span style={{ color: '#ec0043' }} > {t('intro3.h3-2')}</span>
              </h3>
              <div className='intro-flirt-container__text-line'>
              </div>
              <p className='intro-flirt-container__text-sub-about'>
                {t('intro3.p-1')}<span style={{ color: '#ec0043' }} >{t('intro3.p-2')} </span>
                {t('intro3.p-3')} <span style={{ color: '#ec0043' }}>{t('intro3.p-2')}</span> {t('intro3.p-4')}
              </p>
            </div>
          </Col>
          <Col
            xl={{ span: 6, order: 'last' }}
            lg={{ span: 6, order: 'last' }}
            md={{ span: 12, order: 'first' }}
            xs={{ span: 12, order: 'first' }}>
            {/* <Image
              loader={({ src }) => `https://flirtbees.com/images/${src}`}
              src='img_2.webp'
              alt="Intro image 2"
              className='intro-flirt-container__image'
              width='500px'
              height='445px'
              quality={100}
              loading='eager'
            /> */}
            <amp-img src={`https://flirtbees.com/images/img_2.webp`} alt="Intro image 2"
              className='intro-flirt-container__image'
              layout="responsive"
              width="500" height="445" ></amp-img>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
export default Intro
